import React from 'react';
import { CircularProgress } from '@mui/material';

interface StatCardProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'purple' | 'orange' | 'red' | 'cyan' | 'indigo';
  isLoading?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  icon, 
  variant = 'primary', 
  isLoading = false 
}) => {
  const cardClasses = [`statCard`, variant].filter(Boolean).join(' ');

  return (
    <div className={cardClasses}>
      <div className="cardHeader">
        <div className="cardIcon">{icon}</div>
      </div>
      <div className="cardTitle">{title}</div>
      <div className="cardValue">
        {isLoading ? (
          <CircularProgress thickness={5} size={24} sx={{ color: 'white' }} aria-label="טוען נתונים" />
        ) : (
          typeof value === 'number' ? value.toLocaleString() : value
        )}
      </div>
    </div>
  );
};

export default StatCard;